import type { ChatTool, ToolUseProps } from "../components/Chat/ChatTool";
import { ToolStatus } from "../components/Chat/ToolStatus";
import { Text } from "../components/Text";

type Input = { step?: string };

function GetRunExecutionsHeader({
  toolUse,
  result,
  interrupted,
}: ToolUseProps) {
  const input = toolUse.input as Input | undefined;
  const stepName = input?.step;
  const done = !!result && !result.isError;
  const text = done
    ? stepName
      ? `Inspected run results for ${stepName}`
      : "Inspected run results"
    : stepName
      ? `Inspecting run results for ${stepName}…`
      : "Inspecting run results…";
  return (
    <ToolStatus
      icon="text-search"
      text={text}
      pending={!done && !interrupted}
    />
  );
}

function GetRunExecutionsBody({ toolUse, result }: ToolUseProps) {
  return (
    <Text variant="code-small" color="var(--text-secondary)">
      <pre
        style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
      >
        {JSON.stringify(toolUse.input, null, 2)}
      </pre>
      {result && (
        <pre
          style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
        >
          {JSON.stringify(result.output, null, 2)}
        </pre>
      )}
    </Text>
  );
}

export const getRunExecutions: ChatTool = {
  name: "getRunExecutions",
  Header: GetRunExecutionsHeader,
  Body: GetRunExecutionsBody,
};
